var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { title: "Files", icon: "collections" } }),
      _vm._v(" "),
      _c("Subheader", {
        attrs: {
          dense: "",
          title: "Browse By Monitoring Component",
          "no-search": "",
        },
      }),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "", fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            _vm._l(_vm.sortedStationCategories, function (stn) {
              return _c(
                "v-flex",
                {
                  key: stn.Name,
                  staticClass: "my-3",
                  attrs: { xs12: "", sm6: "", md3: "" },
                },
                [
                  _c("TileNavigationButton", {
                    attrs: { title: stn.Name, icon: stn.IconPath },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.viewTile(stn.Name)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "", fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "my-3",
                  attrs: { xs12: "", sm12: "", md6: "", lg4: "" },
                },
                [
                  _c("TileNavigationButton", {
                    attrs: {
                      dark: "",
                      color: "success",
                      title: "Browse All Files",
                      icon: "perm_media",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.viewAll()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "", fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "my-3",
                  attrs: { xs12: "", sm12: "", md6: "", lg4: "" },
                },
                [
                  _c("TileNavigationButton", {
                    attrs: {
                      dark: "",
                      color: "warning",
                      title: "Recycle Bin",
                      icon: "mdi-recycle",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.viewRecycleBin()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }